import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/customers`;

const customersService = {
  getAll: (facilityId, params) => apiClient.get(`${base(facilityId)}/`, { params }),
  getById: (facilityId, id) => apiClient.get(`${base(facilityId)}/${id}`),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, id, data) => apiClient.put(`${base(facilityId)}/${id}`, data),
  delete: (facilityId, id) => apiClient.delete(`${base(facilityId)}/${id}`),
  archive: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/archive`),
  unarchive: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/unarchive`),
  // Gate lockout — sets the stored gate_locked_out state every gate
  // integration reads. Manual lock carries reason="manual" and persists
  // until unlocked (the delinquency job never clears it).
  gateLock: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/gate-lock`),
  gateUnlock: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/gate-unlock`),
};

export default customersService;
